import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-error';
import { isMissingRoute } from './missing-route';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry(failureCount, error) {
          // An answer about the request (permission, validation, a record that is not there or
          // out of reach) does not get better on retry, nor does a route the API does not have;
          // a timeout or a rate limit may.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return error.status === 408 || error.status === 429 ? failureCount < 2 : false;
          }
          if (isMissingRoute(error)) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
